export default __webpack_public_path__ + "static/media/pl.9798a68e.svg";